import { render, staticRenderFns } from "./ShareGroupView.vue?vue&type=template&id=7d35a586&scoped=true&"
import script from "./ShareGroupView.vue?vue&type=script&lang=js&"
export * from "./ShareGroupView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=7d35a586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d35a586",
  null
  
)

export default component.exports